








































































import { Component, Vue, PropSync, Prop, Watch } from 'vue-property-decorator';
import virtualTeachingApi from '@/apis/virtualTeachingAndResearchOffice';
import { mainTypes,levelType } from '@/interfaces/virtualTeachingAndResearchSectionCommonType';
import i18n from '@/lang';

@Component({
  name: 'TopicGoal',
  components: {},
})
export default class TopicGoal extends Vue {
  @PropSync('show', { type: Boolean, default: true }) syncedShow!: boolean;
  @Prop({ type: String, default: '' }) readonly resourceid!: any;
  mainTypes = mainTypes;
  levelType=levelType
  private showLoading: boolean = false;
  private targetData: any = {
    list: [],
    body_type: '1',
  };
  private targetParams: any = {
    resourceid: '',
    page: 1,
    page_size: 20,
  };
  get officeDetails() {
    return this.$store.state.officeDetails;
  }
  @Watch('syncedShow')
  isSyncedShow(n: any, o: any) {
    if (n) {
      this.getTargetList();
    }
  }
  created() {}
  closeDialog() {
    this.syncedShow = false;
  }
  typeTitle(type: string) {
    switch (type) {
      case '1':
        return i18n.t('Home.课程列表');
      case '2':
        return i18n.t('Home.专业列表');
      case '3':
        return i18n.t('Home.教学研究改革主题');
      case '4':
        return i18n.t('Home.教研室主题');
    }
  }
  //获取目标主体
  getTargetList() {
    this.showLoading = true;
    this.targetParams.resourceid = this.resourceid;
    virtualTeachingApi
      .getTargetList(this.targetParams)
      .then((res: any) => {
        this.targetData = res;
        this.showLoading = false;
      })
      .catch(() => {
        this.showLoading = false;
      });
  }
}
